import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { GassClaims } from 'src/app/auth/gass-claims';
import { AllegatiService } from 'src/app/core/allegati.service';
import { NuovoDocumentoService } from 'src/app/core/nuovo-documento.service';
import { DocumentiFTSearchRequest, DocumentiFTSearchResponse, DocumentiSearchDocRow } from 'src/app/shared/models/documento-search.model';
import { DocumentoAllegato } from 'src/app/shared/models/documentoAllegato.model';
import { Posizione } from 'src/app/shared/models/posizione.model';
import { HighlightPipe } from 'src/app/shared/pipes/highlight.pipe';

@Component({
  selector: 'app-fulltext-viewer',
  templateUrl: './fulltext-viewer.component.html',
  styleUrls: ['./fulltext-viewer.component.scss']
})

export class FulltextviewerComponent implements OnChanges {
  @Input() data!: DocumentiFTSearchResponse;
  @Input() searchTerm!: string;
  @Input() totalRecords!: number;
  @Input() pageSize!: number;
  @Output() loadPage = new EventEmitter<DocumentiFTSearchRequest>();

  public items: (MenuItem[] | undefined)[] = [];
  public copies: (string[] | undefined)[] = [];
  public selectedCopies: string[] = [];
  public selectedProtocol: string = '';

  public GassClaims = GassClaims;

  public showCopyDialog = false;

  constructor(private readonly dp: DatePipe,
    private readonly hp: HighlightPipe,
    private readonly router: Router,
    private readonly nuovoDocumentoService: NuovoDocumentoService,
    private readonly allegatiService: AllegatiService) { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.data) {
      this.enrichData();
    }
  }

  private enrichData(): void {
    this.data.results.forEach(el => {
      const data = el.data;
      this.allegatiService.getAllegati(data.documentoId).subscribe(res => {
        this.items[data.documentoId] = [];
        if (res) {
          res.forEach((allegato) => {
            this.items[data.documentoId]!.push({ label: allegato?.fileName, icon: 'pi pi-file', state: { allegato }, style: { 'display': 'flex' }, command: () => this.checkActionAllegato(allegato) });
          });
        }
      });
    });
  }

  formatStato(result: DocumentiSearchDocRow): string {
    return result.stato + ' dal ' + this.dp.transform(result.statoDal, 'longDate', '+0100', 'it') + ' a ' + result.statoUtente;
  }

  getImgArrivo(arrivo: boolean): string {
    return arrivo ? 'assets/images/inbox-in-duotone.svg' : 'assets/images/inbox-out-duotone.svg';
  }

  getEstratto(result: DocumentiSearchDocRow): string {
    if (result.textHighlight) return result.textHighlight;
    if (!result.note) return '';

    const maxlen = 150;
    const highlightedText = this.hp.transform(result.note, this.searchTerm)!;
    if (result.note.length <= maxlen) return highlightedText;

    let subnote: string;
    const index = highlightedText.indexOf(this.hp.startTag);
    if (index <= maxlen / 2) {
      subnote = result.note.substring(0, maxlen - 3) + '...';
    } else if (index >= result.note.length - maxlen) {
      subnote = '...' + result.note.substring(result.note.length - maxlen + 3, result.note.length);
    } else {
      subnote = '...' + result.note.substring(index - (maxlen / 2) + 3, index + (maxlen / 2) - 3) + '...';
    }

    return this.hp.transform(subnote, this.searchTerm) ?? '';
  }

  isNoteHighligthed(note: string): boolean {
    if (!note) {
      return false;
    }
    const split = note.split(/[,.;]| /);
    const terms = this.searchTerm.split(/[,.;]| /).map(t => t.toUpperCase());
    return split.some(n => terms.indexOf(n.toUpperCase()) >= 0);
  }

  loadData(event: { first: number }): void {
    if (!this.searchTerm) return;

    const request = {
      ...this.data.originalRequest,
      pageFirstRow: event.first, pageSize: this.pageSize,
      filters: {
        ...this.data.originalRequest.filters,
        searchTerms: this.searchTerm
      }
    } as DocumentiFTSearchRequest;

    this.loadPage.emit(request);
  }

  checkActionAllegato(allegato: DocumentoAllegato | undefined): void {
    if (!allegato) return;
    // const file_type = allegato.fileName.substr(allegato.fileName.lastIndexOf('.')).toLowerCase();
    // if (file_type === '.pdf' && false) {
    //   this.open(allegato);
    // } else {
    this.download(allegato);
    // }
  }

  open(allegato: DocumentoAllegato): void {
    this.allegatiService.openAllegato(allegato);
  }

  download(allegato: DocumentoAllegato): void {
    this.allegatiService.downloadAllegato(allegato);
  }

  selectedDocument(position: Posizione[]): void {
    this.nuovoDocumentoService.setPosizione(position);
    void this.router.navigate(['nuovo-in-fascicolo']);
  }

  onShowCopyDialog(id: string, value: string[] | null = []): void {
    this.showCopyDialog = true;
    this.selectedProtocol = id;
    this.selectedCopies = value ?? [];
  }

  onHideCopyDialog(): void {
    this.showCopyDialog = false;
    this.selectedCopies = [];
  }
}
